import React from 'react';
import { Flex } from 'antd-v5';
import PropTypes from 'prop-types';

import OnTraccrCheckbox from '../../../common/inputs/OnTraccrCheckbox';
import HoverHelp from '../../../common/HoverHelp';

export default function DropdownFieldFilterCheckboxes({
  labels,
  dataType,
  defaultFilterLabels,
  onChange,
}) {
  const filteredLabels = labels.filter((l) => l.type === dataType.toLowerCase());

  if (!filteredLabels.length) return null;

  function onCheckboxChange(labelId, checked) {
    if (checked) {
      onChange([...defaultFilterLabels, labelId]);
    } else {
      onChange(defaultFilterLabels.filter((id) => id !== labelId));
    }
  }

  return (
    <Flex vertical gap={4} style={{ marginTop: 15 }}>
      <Flex align="center" justify="start" gap={8}>
        Default Filter:
        <HoverHelp
          placement="topRight"
          content={(
            <div style={{ width: 250 }}>
              Select the default filters for this dropdown field.
            </div>
          )}
        />
      </Flex>
      <Flex vertical gap={4}>
        {filteredLabels.map((label) => (
          <OnTraccrCheckbox
            key={label.id}
            label={label.title}
            value={defaultFilterLabels.includes(label.id)}
            onChange={(checked) => onCheckboxChange(label.id, checked)}
          />
        ))}
      </Flex>
    </Flex>
  );
}

DropdownFieldFilterCheckboxes.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.string,
  })),
  dataType: PropTypes.string,
  defaultFilterLabels: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
};

DropdownFieldFilterCheckboxes.defaultProps = {
  labels: [],
  dataType: '',
  defaultFilterLabels: [],
  onChange: () => {},
};
